// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__pXOEW","icon":"SortAdornment_icon__1sFEN","up":"SortAdornment_up__3TOQc","down":"SortAdornment_down__2BRgQ","active":"SortAdornment_active__NxU9h"};